import { render, staticRenderFns } from "./TraitementsEntry.vue?vue&type=template&id=5fd6a351&scoped=true&"
import script from "./TraitementsEntry.vue?vue&type=script&lang=js&"
export * from "./TraitementsEntry.vue?vue&type=script&lang=js&"
import style0 from "./TraitementsEntry.vue?vue&type=style&index=0&id=5fd6a351&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6a351",
  null
  
)

export default component.exports